import Modal from '@/components/organisms/Modal'
import SiteButton from '@/components/atoms/SiteButton'
import { PRODUCT_VIDEOS } from './productVideos'

export interface ProductModalProduct {
    key: string;
    videoKey?: string;
    logo: string;
    alt: string;
    tagline: string;
    description: string;
    screenshot?: string;
    screenshotAlt?: string;
    ctaLabel: string;
    ctaHref: string;
    ctaVariant: 'solid' | 'ghost';
}

interface ProductModalProps {
    product: ProductModalProduct;
    onClose: () => void;
}

// Show the supplied walkthrough when available, otherwise retain the product screenshot.
export function ProductModal({ product, onClose }: ProductModalProps) {
    const video = PRODUCT_VIDEOS[product.videoKey ?? product.key]
    return (
        <Modal onClose={onClose} ariaLabel={`${product.alt} details`}>
            <img src={product.logo} alt={product.alt} className="h-8 w-auto" />

            {video?.walkthroughSrc ? (
                <video
                    src={video.walkthroughSrc}
                    poster={video.posterSrc}
                    controls
                    loop
                    playsInline
                    preload="metadata"
                    aria-label={`${product.alt} walkthrough`}
                    data-analytics-video-title={`unimo-${product.videoKey ?? product.key}-walkthrough`}
                    className="mt-6 aspect-video w-full rounded-site-card bg-unimo-site-grey-100 object-contain"
                >
                    {video.captionsSrc && <track kind="captions" src={video.captionsSrc} srcLang="en" label="English" default />}
                </video>
            ) : product.screenshot ? (
                <img
                    src={product.screenshot}
                    alt={product.screenshotAlt ?? ''}
                    className="mt-6 w-full rounded border-2 border-unimo-site-grey-300"
                />
            ) : null}

            <p className="mt-6 font-medium text-unimo-slate lg:text-lg">{product.tagline}</p>

            <p className="mt-4 font-light text-unimo-slate">{product.description}</p>

            <SiteButton href={product.ctaHref} variant={product.ctaVariant} onClick={onClose} className="mt-8 w-fit">
                {product.ctaLabel}
            </SiteButton>
        </Modal>
    )
}

export default ProductModal
